var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4208 30.4422C39.1484 33.5139 37.1584 36.2206 34.6246 38.3257C32.0907 40.4309 29.0903 41.8703 25.8857 42.5183C22.681 43.1662 19.3697 43.0029 16.2411 42.0426C13.1125 41.0823 10.2621 39.3543 7.93885 37.0096C5.61563 34.6649 3.89043 31.775 2.91408 28.5924C1.93772 25.4098 1.73993 22.0316 2.338 18.753C2.93607 15.4743 4.3118 12.3952 6.3449 9.78472C8.378 7.17425 11.0066 5.11194 14.0008 3.77808M40.4784 14.687C41.279 16.6602 41.7702 18.7463 41.9368 20.8686C41.978 21.3928 41.9986 21.655 41.8966 21.8911C41.8114 22.0884 41.6427 22.2751 41.4568 22.3775C41.2344 22.5002 40.9565 22.5002 40.4008 22.5002H23.6008C23.0408 22.5002 22.7607 22.5002 22.5468 22.3889C22.3587 22.291 22.2057 22.1349 22.1098 21.9428C22.0008 21.7244 22.0008 21.4386 22.0008 20.8668V3.71683C22.0008 3.14952 22.0008 2.86586 22.121 2.63879C22.2213 2.44911 22.4042 2.27682 22.5974 2.18985C22.8287 2.08574 23.0855 2.10676 23.5991 2.14879C25.6781 2.31894 27.7215 2.8203 29.6545 3.63762C32.081 4.66366 34.2858 6.16754 36.1429 8.0634C38.0001 9.95926 39.4733 12.21 40.4784 14.687Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphLight);
export default __webpack_public_path__ + "static/media/graph_light.26f709135697031313582162dde9dff9.svg";
export { ForwardRef as ReactComponent };